import React from 'react';
import { useTranslation } from 'react-i18next';
import './.video-section.less';


function VideoSection(props: { url: any; }) {
    const { t } = useTranslation();
    if(!props.url){
        return <></>
        
    }

    return (
        <div className='video-section'>
            <div className='video-wrapper'>
                <div className='video-aspect-ratio'>
                    <iframe title='ProProctor step by step walkthrough' src={props.url} allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen />
                </div>
            </div>
        </div>
    );
}

export default VideoSection;